// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_mg-0";